// function to enrich accounts with their buildings and job subscriptions to a single object

export default function enrichAccounts(accounts, buildings, subscriptions) {
    // Create a map of subscriptions by their IDs for quick lookup
    const subscriptionsById = subscriptions?.reduce((acc, sub) => {
        acc[sub.JobSubscriptionId] = sub;
        return acc;
    }, {});
  
    // Map buildings to their AccountId, enriching them with their corresponding job subscriptions
    const buildingsByAccount = buildings?.reduce((acc, building) => {
        if (!acc[building.AccountId]) {
            acc[building.AccountId] = [];
        }
        const enrichedBuilding = {
            ...building,
            JobSubscriptions: building.JobSubscriptions?.map(id => subscriptionsById[id])?.filter(sub => sub !== undefined)
        };
        acc[building.AccountId].push(enrichedBuilding);
        return acc;
    }, {});
  
    // Attach matching enriched buildings to each account
    return accounts?.map(account => ({
        ...account,
        Buildings: buildingsByAccount[account.AccountId] || []
    })).filter(account => account.Buildings.length > 0);
  }